// extracted by mini-css-extract-plugin
export default {"main":"styles_main__g2XvM","image":"styles_image__HXEi9"};